/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Stage_In_TransitInputs */

const vi_carrier_stage_in_transit = /** @type {(inputs: Carrier_Stage_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang vận chuyển`)
};

/**

* @param {Carrier_Stage_In_TransitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_stage_in_transit = /** @type {((inputs?: Carrier_Stage_In_TransitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Stage_In_TransitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_stage_in_transit(inputs)
});